import {Injectable} from '@angular/core';
import {TaskData} from '../../models/task-data.model';

@Injectable({
    providedIn: 'root'
})
export class WebworkerService {
    public createWorkerTask<T>(task: (data: TaskData) => Promise<T>, taskData: TaskData): Promise<T> {
        const parts = [
            'try {',
            'addEventListener(\'message\', (event) => {',
            'const data = (event.data) ? JSON.parse(event.data) : undefined;',
            '((' + task.toString() + ')(data)).then(function (res) {postMessage(res);});',
            '});',
            '} catch (e) {',
            'throw(new Error(e));',
            '}'
        ];
        const blob = new Blob(parts, { type: 'text/javascript' });

        return new Promise<T>((resolve, reject) => {
            const url = window.URL.createObjectURL(blob);
            const worker = new Worker(url);
            worker.onmessage = ((event: MessageEvent<T>): void => {
                resolve(event.data);
                worker.terminate();
                window.URL.revokeObjectURL(url);
            });
            worker.onerror = ((event: ErrorEvent): void => {
                reject(event);
                worker.terminate();
                window.URL.revokeObjectURL(url);
            });
            worker.postMessage(JSON.stringify(taskData));
        });
    }
}
